export default __webpack_public_path__ + "static/media/car_how_to_rent.d4a88db9.png";